import { useLocalParticipant, VideoTrack } from '@livekit/components-react';
import { Track } from 'livekit-client';

// ---------------------------------------------------------------------------
// SelfView — local participant's camera, shown as a small PiP tile.
// Renders in the bottom-right corner of the main video area.
// ---------------------------------------------------------------------------
export default function SelfView() {
  const { localParticipant, isCameraEnabled } = useLocalParticipant();

  const cameraPublication = localParticipant?.getTrackPublication(Track.Source.Camera);
  const hasVideo = isCameraEnabled && cameraPublication?.track;

  const initials = (localParticipant?.name || 'You')
    .split(' ')
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  return (
    <div className="lk-self-view">
      {hasVideo ? (
        <VideoTrack
          trackRef={{ participant: localParticipant, publication: cameraPublication, source: Track.Source.Camera }}
          className="lk-self-video"
        />
      ) : (
        <div className="lk-avatar-placeholder">
          <span className="lk-avatar-initials">{initials}</span>
        </div>
      )}
      <p className="lk-self-name">{localParticipant?.name || 'You'}</p>
    </div>
  );
}
